<template>
  <a-card id="type-and-price">
    <h4>{{ $t('product.product_type_and_price') }}</h4>
    <div class="text-muted mb-4">
      {{ $t('product.variant_desc') }}
    </div>

    <a-form-model-item>
      <a-checkbox v-model="catalogs.is_variant" :disabled="isLoading" @change="onChangeVariant">
        {{ $t('product.product_variant') }}
      </a-checkbox>
    </a-form-model-item>

    <SingleVariant
      v-if="!catalogs.is_variant"
      v-model="catalogs"
      :loading="isLoading"
      :currency="currency"
      :uom="uomList"
      :business-id="idBusiness"
      :inventories="inventories"
      :validate-sku="validatingSku"
      @checksku="onCheckSku"
      @addUom="$emit('addUom')"
      @changeUom="e => $emit('changeUom', e)"
      @validate="e => $emit('validate', e)"
    />

    <MultiVariant
      v-else
      v-model="catalogs"
      :loading="isLoading"
      :images="images"
      :default-item="defaultItem"
      :currency="currency"
      :current-uom="uomCurrent"
      :uom="uomList"
      :validate-sku="validatingSku"
      @checksku="onCheckSku"
      @addUom="$emit('addUom')"
      @changeUom="e => $emit('changeUom', e)"
      @title="$emit('title')"
      @upload="e => $emit('upload', e)"
      @validate="e => $emit('validate', e)"
    />
  </a-card>
</template>

<script>
import SingleVariant from './SingleVariant.vue'
import MultiVariant from './MultiVariant.vue'

import { validateSKU } from '@/api/product'

export default {
  name: 'TypeAndPrice',
  components: {
    SingleVariant,
    MultiVariant,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
    inventories: {
      type: Array,
      default: () => [],
    },
    defaultItem: {
      type: Object,
      default: () => {},
    },
    currentUom: {
      type: String,
      default: 'PCS',
    },
    uom: {
      type: Array,
      default: () => [],
    },
    businessId: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: 'IDR',
    },
  },
  data() {
    return {
      isVariants: false,
    }
  },
  computed: {
    catalogs: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    idBusiness() {
      return this.businessId
    },
    uomCurrent() {
      return this.currentUom
    },
    uomList() {
      return this.uom
    },
  },
  methods: {
    async onCheckSku(val) {
      if (!val.sku || val.sku.trim() === '') {
        this.catalogs.items[val.index].sku_exist = 0
      } else if (val.sku.includes(' ')) {
        this.catalogs.items[val.index].sku_exist = 3
      } else {
        let skuCount = 0
        this.catalogs.items.forEach(item => {
          if (item.sku === val.sku) skuCount++
        })

        if (skuCount > 1) {
          this.catalogs.items[val.index].sku_exist = 1
        } else {
          this.catalogs.items[val.index].loading = true
          this.catalogs.items[val.index].sku_exist = await validateSKU({
            business_id: this.idBusiness,
            data: {
              sku: val.sku,
              id: null,
              product_id: null,
            },
          })
          .then(({ data: { data: response } }) => !response ? 4 : 2)
          .catch(() => 2)
          .finally(() => this.catalogs.items[val.index].loading = false)
        }
      }

      this.$emit('validate', `catalogs.items.${val.index}.sku_exist`)
    },
    validatingSku(rule, value, callback) {
      if (value == 0) {
        callback(new Error('SKU harus diisi'))
      } else if (value == 1) {
        callback(new Error('SKU tidak boleh sama'))
      } else if (value == 2) {
        callback(new Error('SKU sudah terdaftar'))
      } else if (value == 3) {
        callback(new Error('SKU tidak boleh ada spasi'))
      } else {
        callback()
      }
    },
    onChangeVariant(event) {
      const { checked } = event.target
      if (this.catalogs.options.length) {
        this.$confirm({
          icon: () => null,
          title: 'Hapus Varian',
          content: 'Jika dirubah, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
          okText: 'Ya, Hapus',
          onOk: () => this.onResetCatalogs(checked),
          onCancel: (close) => {
            this.catalogs.is_variant = this.isVariants
            close()
          },
        })
      } else {
        this.onResetCatalogs(checked)
      }
    },
    onResetCatalogs(checked) {
      const defaultItem = JSON.parse(JSON.stringify(this.defaultItem))
      this.isVariants = checked
      this.catalogs.attributes = {}
      this.catalogs.options = []
      this.catalogs.items = !checked
        ? [{
            ...defaultItem,
            price: {
              ...defaultItem.price,
              uom: this.uomCurrent,
            },
          }]
        : []
      this.catalogs.bundling = {
        bundling_type: null,
        bundles: [],
      }
    },
  },
}
</script>

<style lang="scss">
.variant-price {
  .ant-select-selection__rendered {
    line-height: 38px !important;
  }
}

.variant-uom {
  .ant-select-selection {
    background-color: #343a40 !important;
    color: #fff;
  }
}
</style>